import React from 'react';
import CurrentUser from 'auth/CurrentUser';
import Button from 'components/Button';
import CoachingConstants from 'coaching/CoachingConstants';

type Props = {
  eventKey?: string;
  isCoach?: boolean;
};

export default function CoachingGetHelpButton({ eventKey, isCoach }: Props) {
  const hasCoachHelpPage = CurrentUser.getUser()?.hasFeature('coach_help_page.web.mar-21');
  const linkProps = !isCoach
    ? {
        to: CoachingConstants.COACHING_HELP_ROUTE,
        target: '_blank',
      }
    : hasCoachHelpPage
    ? {
        to: CoachingConstants.COACHING_COACH_HELP_ROUTE,
        target: '_blank',
      }
    : {
        href: CoachingConstants.COACHING_HELP_EMAIL,
      };

  return (
    <Button eventKey={eventKey} {...linkProps}>
      Get help
    </Button>
  );
}
